import { useState } from "react";
export const useDisclosure = (initialIsOpen = false)=>{
  const [isOpen, setIsOpen] = useState(initialIsOpen);
  const onOpen = ()=>setIsOpen(true);
  const onClose = ()=>setIsOpen(false);
  const onToggle = ()=>setIsOpen(!isOpen);
  return {
    isOpen,
    onOpen,
    onClose,
    onToggle
  };
};
//# sourceMappingURL=useDisclosure.js.map